package com.nonopn.skywatcher.design.appbar

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.material.FloatingActionButton
import androidx.compose.material.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier

/**
 * Composable function to display a Multi-Floating Action Button (Multi-FAB) that can be expanded to reveal sub-items.
 *
 * @param modifier The optional [Modifier] for customizing the layout of the Multi-FAB.
 * @param items The list of [FabButtonItem] representing the sub-items to be displayed when the Multi-FAB is expanded.
 * @param fabState The [MutableState] representing the current state of the Multi-FAB, whether it is expanded or collapsed.
 * @param fabIcon The [FabButtonMain] representing the main FAB with an icon and optional rotation.
 * @param fabOption The [FabButtonSub] representing the customization options for the sub-items.
 * @param onFabItemClicked The callback function to handle click events on the sub-items.
 * @param stateChanged The optional callback function to notify when the state of the Multi-FAB changes (expanded or collapsed).
 */
@Composable
fun FloatingActionButton(
    modifier: Modifier = Modifier,
    floatingActionButtonState: FloatingActionButtonState.Button,
    stateChanged: (fabState: FabButtonState) -> Unit = {}
) {
    Column(
        modifier = modifier.wrapContentSize(),
        horizontalAlignment = Alignment.End
    ) {
        // Main FloatingActionButton representing the Multi-FAB
        FloatingActionButton(
            onClick = floatingActionButtonState.action,
            // containerColor = fabOption.backgroundTint,
            // contentColor = fabOption.iconTint
        ) {
            // Icon for the main FAB with optional rotation based on its state (expanded or collapsed)
            Icon(
                imageVector = floatingActionButtonState.icon,
                contentDescription = floatingActionButtonState.contentDescription,
                modifier = Modifier,
                // tint = fabOption.iconTint
            )
        }
    }
}
